import React, { useMemo, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ADMIN_URL } from '../../../Admin/constants/constants';
import debounce from 'lodash/debounce';
import querystring from 'RootShared/utility/querystring';
import cn from 'classnames';
import { StatusKeys } from '../../query';

import Input from 'Components/Input';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';
import PlusSVG from 'Components/Admin/assets/PlusSVG';
import SearchSVG from 'Components/Admin/assets/SearchSVG';

const Dashboard = ({ onTermChange, onTabChange, searchInputValue, mainUrl, currentStatus }) => {
  const [isMobileLinksOpen, setIsMobileLinksOpen] = useState(false);

  const getUrl = (status) => ({
    pathname: mainUrl,
    search: querystring.stringify({ status }),
  });

  const links = useMemo(() => ([
    { status: StatusKeys.PROGRESS, title: 'In Progress', url: getUrl(StatusKeys.PROGRESS) },
    { status: StatusKeys.HOLD, title: 'On Hold', url: getUrl(StatusKeys.HOLD) },
    { status: StatusKeys.NEW, title: 'New', url: getUrl(StatusKeys.NEW) },
    { status: StatusKeys.FINISHED, title: 'Finished', url: getUrl(StatusKeys.FINISHED) },
  ]), [mainUrl]);

  const currentPage = useMemo(() => {
    return links.find((i) => i.status === currentStatus);
  }, [currentStatus, links]);

  const setSearchInputValueDebounced = debounce(onTermChange, 500);

  const handleChange = (e) => {
    setSearchInputValueDebounced({ term: e.target.value });
  };

  const searchInput = useMemo(() => {
    return (
      <Input
        icon={<SearchSVG />}
        className="search__input"
        initialFocusState={window.outerWidth > 1024}
        id="search__project"
        fieldProps={{
          name: 'search',
          placeholder: 'Search',
          onChange: handleChange,
          value: searchInputValue,
          onClick: (event) => event.stopPropagation(),
        }}
      />
    );
  }, [searchInputValue, onTermChange]);

  const desktopMenu = useMemo(() => {
    return (
      <ul className="dashboard__links-desktop">
        {links.map((l) => (
          <li key={l.status}>
            <NavLink
              exact
              to={l.url}
              activeClassName={cn({ active: currentPage?.status === l.status })}
              onClick={onTabChange.bind(null, l.status)}
            >
              {l.title}
            </NavLink>
          </li>
        ))}
      </ul>
    );
  }, [currentPage, links]);

  const mobileMenu = useMemo(() => {
    return (
      <>
        <button
          type="button"
          onClick={() => setIsMobileLinksOpen(!isMobileLinksOpen)}
          className="dashboard__mobile-link-switcher"
        >
          <span>{currentPage?.title}</span>
          <TriangleIcon direction={isMobileLinksOpen ? 'up' : 'down'} />
        </button>
        <ul className={`dashboard__links-mobile ${isMobileLinksOpen ? 'open' : ''}`}>
          {links.map((l) => (
            <li key={l.status}>
              <NavLink exact to={l.url} onClick={() => setIsMobileLinksOpen(false)}>
                {l.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </>
    );
  }, [currentPage, isMobileLinksOpen]);

  return (
    <div className="dashboard">
      <div className="dashboard__tabs">
        {mobileMenu}
        {desktopMenu}
      </div>
      <div className="dashboard__left">
        <div className="dashboard__search">{searchInput}</div>
        <div className="dashboard__buttons">
          <Link
            exact="true"
            to={`/${ADMIN_URL}/projects/create/`}
            className="button button_secondary button-add-project"
          >
            Projects
            <PlusSVG />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
